<template>
  <div class="modal" @mousedown="closeModal">
    <div class="card" style="max-width: 500px">
      <div class="card-header">
        <h1>Edit Form URL</h1>
        <p>Change the URL for {{ form.name }}</p>
      </div>
      <form class="card-body" @submit.prevent="onSave">
        <div class="form-group">
          <label for="url-input">Form URL</label>
          <input id="url-input" ref="urlInput" v-model="editableUrl" @keyup.escape="onCancel" class="url-input"
            placeholder="form-url" />
          <p class="help-text">Only lowercase letters, numbers, and hyphens allowed</p>
        </div>

        <div class="url-preview">
          <strong>Full URL:</strong><br>
          {{ getFullUrl() }}
        </div>

        <p v-if="urlError" class="error">{{ urlError }}</p>

        <div class="button-group">
          <button type="submit" class="button primary">Save URL</button>
          <button type="button" @click="onCancel" class="button secondary">Cancel</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { updateFormUrl } from "@/api";

export default {
  name: "EditFormUrlModal",
  props: {
    form: Object,
  },
  data() {
    return {
      editableUrl: this.form.url,
      urlError: ''
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.urlInput) {
        this.$refs.urlInput.focus();
        this.$refs.urlInput.select();
      }
    });
  },
  methods: {
    closeModal(event) {
      if (event.target.className != "modal") {
        return;
      }
      this.onCancel();
    },
    onCancel() {
      this.$emit("closeModal");
    },
    getFullUrl() {
      const protocol = window.location.protocol;
      const host = window.location.host;
      const account = this.form.ownerNameUnique;
      const url = this.editableUrl.trim() || this.form.url;
      return `${protocol}//${host}/${account}/${url}`;
    },
    async onSave() {
      const newUrl = this.editableUrl.trim();

      // Client-side validation
      if (!newUrl) {
        this.urlError = 'URL cannot be empty';
        return;
      }

      const urlPattern = /^[a-z0-9-]+$/;
      if (!urlPattern.test(newUrl)) {
        this.urlError = 'URL can only contain lowercase letters, numbers, and hyphens';
        return;
      }

      if (newUrl === this.form.url) {
        this.$emit("closeModal");
        return;
      }

      try {
        this.urlError = '';
        await updateFormUrl(this.form.id, newUrl);
        this.$emit("urlUpdated", newUrl);
        this.$emit("closeModal");
      } catch (err) {
        console.error('Failed to update form URL', err);
        this.urlError = err.message || 'Failed to update URL';
      }
    }
  },
  emits: ["closeModal", "urlUpdated"],
};
</script>

<style scoped>
.card-header h1 {
  margin-bottom: 8px;
}

.card-header p {
  color: #6b7280;
  font-size: 14px;
  margin: 0;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
  color: #374151;
  font-size: 14px;
}

.url-input {
  width: 100%;
  padding: 10px 12px;
  font-size: 16px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-family: monospace;
  transition: border-color 0.2s ease;
}

.url-input:focus {
  outline: none;
  border-color: #9333ea;
  box-shadow: 0 0 0 3px rgba(147, 51, 234, 0.1);
}

.help-text {
  margin-top: 6px;
  font-size: 12px;
  color: #6b7280;
}

.url-preview {
  margin-bottom: 20px;
  padding: 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 13px;
  color: #374151;
  word-break: break-all;
}

.url-preview strong {
  color: #111827;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.button-group {
  display: flex;
  gap: 10px;
}

.button {
  flex: 1;
}

.error {
  color: #dc2626;
  font-size: 14px;
  margin-bottom: 16px;
  padding: 10px 12px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 6px;
}
</style>
